export default __webpack_public_path__ + "static/media/steamship.5d8df430.svg";